addScriptToQueue(() => {
    require('./src/script-p2');
}, 0);
